/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type QuickViewItem_item$ref = any;
export type QuickViewItem_item = {
    readonly quickViewDisplay: {
        readonly title: string | null;
        readonly mobileTitle: string | null;
        readonly paragraphs: ReadonlyArray<{
            readonly key: string | null;
            readonly text: string | null;
            readonly mobileText: string | null;
        } | null> | null;
    } | null;
    readonly " $refType": QuickViewItem_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "Literal",
            "name": "formatType",
            "value": "MOBILE"
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "QuickViewItem_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "quickViewDisplay",
                "storageKey": null,
                "args": null,
                "concreteType": "QuickViewDisplayType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": "mobileTitle",
                        "name": "title",
                        "args": (v0 /*: any*/),
                        "storageKey": "title(formatType:\"MOBILE\")"
                    },
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "paragraphs",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "QuickViewParagraph",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "key",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "text",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": "mobileText",
                                "name": "text",
                                "args": (v0 /*: any*/),
                                "storageKey": "text(formatType:\"MOBILE\")"
                            }
                        ]
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'ac0879028d15ff77d71434a06957c0ee';
export default node;
